import React, { useEffect } from "react";
import { Form, Input, Button, Row, Col, Select} from "antd";
import { useDispatch, useSelector } from "react-redux";
import { fetchEmployeeTypesRequest } from '../../../redux/actions/employeeActions';
import { fetchProvinceTypesRequest } from '../../../redux/actions/provinceActions';
import { fetchSiteRequest } from '../../../redux/actions/siteActions';

const EditEmployeeForm = ({
  employee,
  sitenames = [],
  // provinces = [],
  cities = [],
  onSubmit,
  closeModal,
}) => {
  const [form] = Form.useForm();
  const { Option } = Select;
  const user = JSON.parse(localStorage.getItem('user'));
  const dispatch = useDispatch();

  const { employeeTypes, provinces, sites } = useSelector(state => ({
    employeeTypes: state.employeeType.employeeTypes,
    provinces: state.provinceType.provinceTypes,
    sites: state.site.data || [],
  }));

  useEffect(() => {
    dispatch(fetchEmployeeTypesRequest());
      dispatch(fetchProvinceTypesRequest());
      dispatch(fetchSiteRequest());
  }, [dispatch]);

  // Prefill the form with employee data
  useEffect(() => {
    if (employee) {
      form.setFieldsValue({
        ...employee,
        sitename: employee.sitename || "", // Ensure the key matches the Select field
        province: employee.province || "", // For province dropdown
      });
    }
  }, [employee, form]);

  // Handle form submission
  const handleFinish = (values) => {
    const updatedEmployee = {
      ...employee, // Preserve existing data
      ...values, // Update with form values
    };

    if (onSubmit) {
      onSubmit(updatedEmployee); // Pass updated data to parent
    }
    
  };

  return (
    <Form
      form={form}
      layout="vertical"
      onFinish={handleFinish}
    >
      <Row gutter={16}>
      <Col xs={24} sm={12} md={8}>
          <Form.Item label="Employee Number" name="empno">
            <Input disabled />
          </Form.Item>
        </Col>

        {
            user?.role === "SUPERADMIN" && (
         <Col xs={24} sm={12} md={8}>
        <Form.Item
  label="Site"
  name="sitename"
  rules={[{  message: "Please select a site" }]}
>
  <Select
    placeholder="Select a site"
    options={sites.map((site) => ({
      value: site.sitename, // Replace with actual field if different
      label: site.sitename,
    }))}
  />
</Form.Item>
        </Col> 
)
}

<Col xs={24} sm={12} md={8}>
        <Form.Item
              name="emptypeid"
              label="Employee Type"
            >
              <Select
                value={employee.emptypeid}
                onChange={(value) => ({ ...employee, emptypeid: value })}
                placeholder="Select Employee Type"
              >
                {employeeTypes && employeeTypes.map((type) => (
                  <Option key={type.id} value={type.id}>
                    {type.emptype}
                  </Option>
                ))}
              </Select>
            </Form.Item>
        </Col>
      </Row>

      <Row gutter={16}>
  
      <Col xs={24} sm={12} md={8}>
          <Form.Item
            label="First Name"
            name="firstname"
            rules={[{  message: "Please enter the first name" }]}
          >
            <Input />
          </Form.Item>
        </Col>

        <Col xs={24} sm={12} md={8}>
          <Form.Item label="Middle Name" name="middlename">
            <Input />
          </Form.Item>
        </Col>

        <Col xs={24} sm={12} md={8}>
          <Form.Item
            label="Last Name"
            name="lastname"
            rules={[{ message: "Please enter the last name" }]}
          >
            <Input />
          </Form.Item>
        </Col>
      </Row>

      {/* Address Section */}
      <Row gutter={16}>



             {/* City Section */}
             <Col xs={24} sm={12} md={8}>
          <Form.Item
            label="City"
            name="city"
          >
             <Input />
          </Form.Item>
        </Col>

        <Col xs={24} sm={12} md={8}>
          <Form.Item label="Address" name="address">
            <Input />
          </Form.Item>
        </Col>

   

        {/* Province Section */}
        <Col xs={24} sm={12} md={8}>
          <Form.Item
            label="Province"
            name="province"
            rules={[{  message: "Please select a province" }]}
          >
            <Select
              options={provinces.map((province) => ({
                value: province.province,
                label: province.province,
              }))}
            />
          </Form.Item>
        </Col>
      </Row>

      {/* Miscellaneous Information */}
      <Row gutter={16}>

      <Col xs={24} sm={12} md={8}>
          <Form.Item
            label="Phone"
            name="phone"
            rules={[{ message: "Please enter the phone number" }]}
          >
            <Input />
          </Form.Item>
        </Col>

        <Col xs={24} sm={12} md={8}>
          <Form.Item
            label="Email"
            name="email"
            rules={[
              {  message: "Please enter the email" },
              { type: "email", message: "Please enter a valid email" },
            ]}
          >
            <Input />
          </Form.Item>
        </Col>
 

      </Row>

      {/* Buttons */}
      <div  style={{ width: '200px', margin: '0 auto', display: 'block', lineHeight: '5px', }}>
        <Button type="primary" htmlType="submit" style={{ marginRight: "10px" }}>
          Save
        </Button>
      </div>
    </Form>
  );
};

export default EditEmployeeForm;
